import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { api } from "@/lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [width, setWidth] = useState(0);
  const track = useRef(null);

  useEffect(() => { api.get("/testimonials").then(({ data }) => setItems(data)); }, []);
  useEffect(() => {
    if (track.current) setWidth(track.current.scrollWidth - track.current.offsetWidth);
  }, [items]);

  return (
    <section data-testid="testimonials-section" className="overflow-hidden bg-brand-offwhite">
      <div className="container-rv py-24 lg:py-32">
        <Reveal className="mb-12 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="overline text-brand-red">Loved by Ottawa</p>
            <h2 className="mt-4 font-serif text-4xl font-bold text-brand-charcoal sm:text-5xl">
              The feeling is unanimous
            </h2>
          </div>
          <p className="max-w-xs text-sm text-brand-muted">Drag to explore real words from real neighbours across the city.</p>
        </Reveal>
      </div>

      <div className="container-rv pb-24 lg:pb-32">
        <motion.div ref={track} className="cursor-grab overflow-hidden active:cursor-grabbing">
          <motion.div
            drag="x"
            dragConstraints={{ right: 0, left: -width }}
            className="flex gap-6"
          >
            {items.map((t, i) => (
              <div
                key={i}
                data-testid={`testimonial-card-${i}`}
                className="card-rv relative min-w-[300px] max-w-[340px] shrink-0 p-8 hover:-translate-y-1 hover:shadow-[0_24px_60px_-40px_rgba(26,28,30,0.5)]"
              >
                <Quote className="h-10 w-10 fill-brand-silver/30 text-brand-silver/30" />
                <p className="mt-4 text-brand-charcoal leading-relaxed">"{t.quote}"</p>
                <div className="mt-6 flex items-center justify-between border-t border-brand-silver/30 pt-5">
                  <div>
                    <p className="font-semibold text-brand-charcoal">{t.name}</p>
                    <p className="text-xs uppercase tracking-wider text-brand-muted">{t.area}</p>
                  </div>
                  <div className="flex">
                    {[...Array(t.rating)].map((_, s) => <Star key={s} className="h-4 w-4 fill-brand-red text-brand-red" />)}
                  </div>
                </div>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
